/** Shared dark UI palette — pure black on mobile and web. */
export const DARK_UI = {
  bg: "#000000",
  text: "#ffffff",
  muted: "rgba(255, 255, 255, 0.55)",
  mutedSoft: "rgba(255, 255, 255, 0.45)",
  border: "rgba(255, 255, 255, 0.12)",
  surface: "#000000",
  rowSelected: "#1a1a1a",
  gridLine: "rgba(255, 255, 255, 0.08)",
  inputBg: "#0a0a0a",
  buttonBg: "#141414",
};
